// src/components/FeaturedProducts.js
import React from 'react';
import { catalogoData } from '../data'; // Importamos los datos
import ProductCard from './ProductCard'; // Importamos la tarjeta
import './FeaturedProducts.css';

const FeaturedProducts = () => {
  // Seleccionamos los primeros 3 productos para destacarlos
  const featured = catalogoData.slice(0, 3);

  return (
    <section className="featured-products-section">
      <div className="container">
        <h2 className="section-title">Nuestros Productos Destacados</h2>
        <div className="featured-products-grid">
          {featured.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;